export const UNKNOWN_SCHEMA = 'UNKNOWN_SCHEMA';
export const ROOT_QUERY_INCLUDE_VARIABLE_NAME = 'rootQueryInclude';

//# sourceMappingURL=constants.js.map